export const produceDateToTable = (value: string): string => {
  const [left, right] = value.split("T");
  const [year, month, date] = left.split("-");
  const [hours, minutes, seconds] = right.replace("Z", "").split(":");
  return `${date}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};
